import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import highlight from 'scoreboard/components/highlight'

var loremRegExp = /(lorem|ipsum|dolor)/i
/**
 * Creates a preview for text replacement functions available
 * in Report Mass Edit.
 * Returns before and after lorem ipsum text snippets,
 * where "before" is an example of what the text would be before the change, and
 * "after" is what it would be changed to based on the user's inputs and the
 * chosen text replacement type
 */
var textTransformer = {

	entire: function(newText) {
		return {
			before: this.loremPreview(newText),
			after: highlight(newText)
		}
	},

	exact: function(textToReplace, newText) {
		if (_.isEmpty(textToReplace)) {
			return this.defaults()
		}
		var before
		if (loremRegExp.test(textToReplace)) {
			before = i18n.get('preview.Exercitation') + ' ' + textToReplace + ' ' + i18n.get('preview.UllamcoLab') + textToReplace + i18n.get('preview.oris')
		} else {
			before = i18n.get('preview.Lorem') + ' ' + textToReplace + ' ' + i18n.get('preview.IpsumDol') + ' ' + textToReplace + i18n.get('preview.or')
		}
		return {
			before: before,
			after: _.replace(before, new RegExp(_.escapeRegExp(textToReplace), 'g'), highlight(newText))
		}
	},

	between: function(textBefore, textAfter, newText) {
		if (_.isEmpty(textBefore) && _.isEmpty(textAfter)) {
			return this.defaults()
		}
		var before
		if (loremRegExp.test(textBefore) || loremRegExp.test(textAfter)) {
			before = i18n.get('preview.Exercitation') + ' ' + textBefore + i18n.get('preview.Ullamco') + textAfter + ' ' + i18n.get('preview.Lab') + textBefore + textAfter + i18n.get('preview.oris')
		} else {
			before = i18n.get('preview.Lorem') + ' ' + textBefore + i18n.get('preview.Ipsum') +  textAfter + ' ' + i18n.get('preview.Dol') + textBefore + textAfter + i18n.get('preview.or')
		}
		return {
			before: before,
			after: before.replace(new RegExp('(' + _.escapeRegExp(textBefore) + ')(.*?)(' + _.escapeRegExp(textAfter) + ')', 'g'), '$1' + highlight(newText) + '$3')
		}
	},

	prepend: function(newText) {
		return {
			before: this.loremPreview(),
			after: highlight(newText) +this.loremPreview()
		}
	},

	append: function(newText) {
		return {
			before: this.loremPreview(),
			after: this.loremPreview() + highlight(newText)
		}
	},

	defaults: function() {
		return {
			before: this.loremPreview(),
			after: this.loremPreview()
		}
	},

	// if text specified is 'Lorem Ipsum', return a different phrase
	loremPreview: function(text) {
		return text === i18n.get('preview.LoremIpsum') ? i18n.get('preview.ExercitationUllamco') : i18n.get('preview.LoremIpsum')
	}

}

export default textTransformer

textTransformer.__filename__ = 'admin/mass-edit/text-transformer.js'
